import { handleError } from "../../../util/errors";
import apiBase from "../../api";
import {
  FETCH_OBJECT_CODES,
  FETCH_OBJECT_CODE,
  CREATE_OBJECT_CODE,
  UPDATE_OBJECT_CODE,
  DELETE_OBJECT_CODE,
} from "../../urls";

class ObjectCodesService {
  getObjectCodes = async (page = 1, perPage = 100, isActive = true, search = "", sortBy = "id", order = "ASC") => {
    try {
      const response = await apiBase.get(FETCH_OBJECT_CODES(page, perPage, isActive, search, sortBy, order));
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching object codes");
    }
  };

  getObjectCode = async (id) => {
    try {
      const response = await apiBase.get(FETCH_OBJECT_CODE(id));
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching object code");
    }
  };

  createObjectCode = async (objectCodeData) => {
    try {
      const response = await apiBase.post(CREATE_OBJECT_CODE, objectCodeData);
      if (response.status !== 200 && response.status !== 201) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error creating object code");
    }
  };

  updateObjectCode = async (id, objectCodeData) => {
    try {
      const response = await apiBase.put(UPDATE_OBJECT_CODE(id), objectCodeData);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error updating object code");
    }
  };

  deleteObjectCode = async (id) => {
    try {
      const response = await apiBase.delete(DELETE_OBJECT_CODE(id));
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error deleting object code");
    }
  };
}

export default new ObjectCodesService();

